import { TableColumn } from "../table/TableColumn";

const PresetReaderColumns: TableColumn[] = [
    {
        heading: "Name",
        accessor: "name",
        isNumeric: false,
        id: 0,
        sortByName: "devName",
        sortDirection: "asc",
        active: true,
        translationKey: "name"
    },
    {
        heading: "Fixed Address",
        accessor: "fixedAddress",
        isNumeric: false,
        id: 1,
        sortByName: "devFixedAddr",
        sortDirection: "asc",
        active: true,
        translationKey: "fixedAddress"
    },
    {
        heading: "IP Address",
        accessor: "ipAddress",
        isNumeric: false,
        id: 2,
        sortByName: "devIpAddress",
        sortDirection: "asc",
        active: true,
        translationKey: "ipAddress"
    },
    {
        heading: "Type",
        accessor: "type",
        isNumeric: false,
        id: 3,
        sortByName: "unitType.trnName",
        sortDirection: "asc",
        active: true,
        translationKey: "type"
    }

];

export default PresetReaderColumns;
